/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function WorkorderSetSubStatusCommandFromJSON(json) {
    return WorkorderSetSubStatusCommandFromJSONTyped(json, false);
}
export function WorkorderSetSubStatusCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'requestedStatus': !exists(json, 'requestedStatus') ? undefined : json['requestedStatus'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
    };
}
export function WorkorderSetSubStatusCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'requestedStatus': value.requestedStatus,
        'user': UserToJSON(value.user),
    };
}
